module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("itwJG"))).then(() => parcelRequire('5erN3'));